<!--
File Name          : sensor-color.component.html
Author             : Jared Laine Dyreson
Version            : 0.1.0
Date               : 2026-03-18
Description        : Short Description (manual edit required)

Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
This file is subject to the terms and conditions defined in
file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
-->



<div class="svg-wrapper"
     (mousemove)="showTooltip($event)"
     (mouseleave)="hideTooltip()">

  <svg width="32" height="32" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 40.27 40.27" [style.color]="deviceColor" (click)="clicked()" (keydown.enter)="clicked()" (keydown.space)="clicked()" [attr.tabindex]="tooltipText ? 0 : -1" [attr.role]="tooltipText ? 'button' : 'img'" [attr.aria-label]="tooltipText ?? 'Sensor color indicator'" [style.cursor]="tooltipText ? 'pointer' : 'default'">
    <path fill="#f0f0f0" d="M28.47,40.27H11.79L0,28.47V11.79L11.79,0h16.68l11.79,11.79v16.68l-11.79,11.79h0ZM12.62,38.27h15.02l10.62-10.62v-15.02L27.64,2h-15.02L2,12.62v15.02l10.62,10.62h0Z"/>
    <polygon fill="#010101" points="38.27 20.13 2.01 20.13 2.01 27.64 12.62 38.26 12.62 38.27 27.65 38.27 38.27 27.65 38.27 20.13"/>
    <polygon [attr.fill]="deviceColor" [ngClass]="led_pattern" points="2.01 20.13 38.27 20.13 38.27 12.63 27.65 2 12.62 2 2.01 12.62 2.01 20.13"/>
    
  </svg>
  <svg *ngIf="showNotification" style="position:absolute;top:0;bottom:0;left:0;right:0;" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-5.0 -10.0 110.0 135.0">
    <path fill="red" d="m41.168 77.664c2.2617-2.2617 5.3867-3.6602 8.8398-3.6602 3.4492 0 6.5742 1.4023 8.8398 3.6602 2.2617 2.2617 3.6602 5.3867 3.6602 8.8398 0 3.4492-1.4023 6.5742-3.6602 8.8398-2.2617 2.2617-5.3867 3.6602-8.8398 3.6602-3.4492 0-6.5742-1.4023-8.8398-3.6602-2.2617-2.2617-3.6602-5.3867-3.6602-8.8398 0-3.4492 1.4023-6.5742 3.6602-8.8398zm19.41-13.141h-21.145v-0.007813c-1.207 0-2.2188-0.9375-2.2891-2.1562l-3.4961-58.773c-0.011719-0.097657-0.019532-0.19141-0.019532-0.28906 0-1.2695 1.0273-2.2969 2.2969-2.2969h28.152v0.007812l0.13672 0.007813c1.2617 0.070313 2.2305 1.1562 2.1523 2.4219l-3.4961 58.797c0 1.2695-1.0273 2.2969-2.2969 2.2969z"/>
  </svg>

  <div
    class="tooltip"
    *ngIf="tooltip.visible"
    [style.left.px]="tooltip.x"
    [style.top.px]="tooltip.y">
    {{ tooltip.text }}
  </div>
</div>